import { FormSectionElements, ProgramContainer } from "../entities/formTemplateDataType";
import { getAddress } from "./addressUtils";
import { UPloadFileItemProps } from "../runtimeComponent/subComponent/FileUploadComponent";
import SessionStorageService from "../services/SessionStorageService";
import { FormEntity } from "../entities/FormEntity";
import axios from "axios";
import URLUtils from "./URLUtils";
import * as CircularJSON from 'circular-json';
export default class DataUtils {

  private static findControlToBind = (programContainer, fieldName) => {
    let returnedEle;
    outerLoop: for (let formSection of programContainer.ListOfFormSections) {
      for (let subSection of formSection.ListOfFormSubSections) {
        for (let ele of subSection.ListOfFormSectionElements) {

          if (ele.LoadBindName == fieldName) {
            returnedEle = ele;
            break outerLoop;
          }
        }
      }
    }
    return returnedEle;
  }

  static assignFormValue = (programContainer: ProgramContainer) => {
    const entity = programContainer.Entity;
    const formValue = entity.formValue;
    let formValueObject;
    if (formValue) {
      formValueObject = CircularJSON.parse(formValue);
    } else {
      formValueObject = entity;
    }

    const flattenedEntity = DataUtils.flattenObject(formValueObject);

    Object.entries(flattenedEntity).forEach(
      ([key, value]) => {
        var element = DataUtils.findControlToBind(programContainer, key);
        if (element != null) {
          element.Value = value;
          if (element.Datatype == "Checkbox" && "Y" !== programContainer.CheckboxValueYN) {
            element.Value = value ? "Y" : "N";
          }
        }
      }
    )
  }

  static collectFormValue = (programContainer: ProgramContainer, siebelUpdatableOnly = 'N', lang = 'en') => {
    // console.log(siebelUpdatableOnly);
    let obj = {};

    if (programContainer.GetAPI) {
      const regex = /\/\{(\w+)\}\/\{(\w+)\}/;
      const matches = programContainer.GetAPI.match(regex);
      if (matches) {
        for (let i = 1; i < matches.length; i++) {
          if (programContainer[`{${matches[i]}}`] == undefined)
            programContainer[`{${matches[i]}}`] = null;

          obj[matches[i]] = programContainer[`{${matches[i]}}`]
        }
      }

    }

    const profile = programContainer.Profile;

    if (profile) {
      for (let formSection of programContainer.ListOfFormSections) {
        for (let subSection of formSection.ListOfFormSubSections) {
          for (let ele of subSection.ListOfFormSectionElements) {
            if (ele.Datatype == 'HiddenField')
              obj[ele.LoadBindName] = profile[ele.LoadBindName];
          }
        }
      }
    }

    for (let formSection of programContainer.ListOfFormSections) {
      for (let subSection of formSection.ListOfFormSubSections) {
        for (let ele of subSection.ListOfFormSectionElements) {
          if (ele.Datatype == 'Label' || ele.Datatype == "Accordions" || ele.Datatype == 'HTML' || ele.LoadBindName == "" || ele.LoadBindName == null || ele.Datatype == "Button" || ele.Datatype == "PublicSecureButton" || ele.Datatype == "Feedback" || ele.Datatype == "SuccessAlert" || ele.Datatype == "WarningAlert" ||ele.LoadBindName == undefined) {
            continue;
          }
          if (siebelUpdatableOnly == 'Y') {
            // console.log(ele);
            if (ele.UpdateField != null) {
              if (ele.Value == null) {
                if (ele.Datatype == "Checkbox") {
                  ele.Value = "N";
                } else {
                  ele.Value = "";
                }
              }
              obj[ele.UpdateField] = ele.Value;
            }
          } else {
            if (ele.Datatype == "Checkbox" && "Y" !== programContainer.CheckboxValueYN) {
              ele.Value = (ele.Value == "Y");
              obj[ele.LoadBindName] = ele.Value;
            } else if (ele.Datatype == "Address") {
              obj[ele.LoadBindName] = getAddress(ele.Address || programContainer.Profile?.address, false, lang);
            } else if (ele.Datatype == "GoogleLookUpAddress") {
              if (ele.Value != null && ele["streetName"] != null) {
                obj[ele["unitNumber"]] = ele.Value != null ? ele?.Value["addressLine2"] : null;
                const streetNumberPattern = /^\d+/;
                const match1 = ele.Value["addressLine1"]?.match(streetNumberPattern);
                if (match1) {
                  obj[ele["streetNumber"]] = match1[0];
                }
                const regex2 = /\d+\s+(.+)/;
                const match2 = ele.Value["addressLine1"]?.match(regex2);
                if (match2) {
                  obj[ele["streetName"]] = match2[1];
                }
                const regex3 = /(\bNorth\b|\bSouth\b|\bEast\b|\bWest\b)/;
                const match3 = ele.Value["addressLine1"]?.match(regex3);
                if (match3) {
                  obj[ele["streetDirection"]] = match3[1];
                }
                const regex4 = /\b(Street|Avenue|Boulevard|Drive|Road|Lane|Way|Circle|Parkway)\b/i;
                const match4 = ele.Value["addressLine1"]?.match(regex4);
                if (match4) {
                  obj[ele["streetType"]] = match4[1];
                }

                obj[ele["city"]] = ele.Value["city"];
                obj[ele["province"]] = ele.Value["province"];
                obj[ele["postalCode"]] = ele.Value["postalCode"];
              }
            } else if (ele.Datatype == "File") {
              obj[ele.LoadBindName] = ele.Value.map((file: UPloadFileItemProps) => ({ attachment: file.attachment, path: file.file.name }));
            } else {
              obj[ele.LoadBindName] = ele.Value;
            }
          }
        }
      }

    }
    let jsonObject = DataUtils.unflattenObject(obj);

    return jsonObject;

  }

  static flattenObject(obj: any, prefix = ''): FlattenedObject {
    const result: FlattenedObject = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        const newKey = prefix ? `${prefix}.${key}` : key;

        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
          result[newKey] = value;
          const flattenedSubObject = DataUtils.flattenObject(value, newKey);
          Object.assign(result, flattenedSubObject);
        } else {
          result[newKey] = value;
        }
      }
    }

    return result;
  }

  private static unflattenObject(obj: any): FlattenedObject {
    const result: FlattenedObject = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        const keys = key.split('.');
        let currentObj = result;
        for (let i = 0; i < keys.length - 1; i++) {
          const nestedKey = keys[i];
          if (!currentObj.hasOwnProperty(nestedKey) || typeof currentObj[nestedKey] !== 'object' || currentObj[nestedKey] === null || Array.isArray(currentObj[nestedKey])) {
            currentObj[nestedKey] = {};
          }

          currentObj = currentObj[nestedKey];
        }

        const lastKey = keys[keys.length - 1];
        currentObj[lastKey] = value;
      }
    }

    return result;
  }

  static compareArraysOfObjects(arr1, arr2) {
    if (arr1 == null && arr2 != null || arr2 == null && arr1 != null) return false;
    if (arr1 == null && arr2 == null) return true;

    if (Array.isArray(arr1) && Array.isArray(arr2) && arr1.length !== arr2.length) {
      return false; // Different lengths, not equal
    }

    for (let i = 0; i < arr1.length; i++) {
      const obj1 = arr1[i];
      const obj2 = arr2.find(item => this.areObjectsEqual(item, obj1));

      if (!obj2) {
        return false; // Object not found in arr2, not equal
      }
    }

    return true; // All objects found, arrays are equal
  }

  static areObjectsEqual(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false; // Different number of properties, not equal
    }

    for (let key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return false; // Property values are not equal, not equal
      }
    }

    return true; // All properties are equal
  }

  static findControl = (field: FormSectionElements, targetFieldName) => {
    let returnedEle;
    const programContainer = field.parent.parent.parent;
    outerLoop: for (let formSection of programContainer.ListOfFormSections) {
      for (let subSection of formSection.ListOfFormSubSections) {
        for (let ele of subSection.ListOfFormSectionElements) {

          if (ele.LoadBindName == field.LoadBindName) {
            returnedEle = ele;
            break outerLoop;
          }
        }
      }
    }
    return returnedEle;
  }


  static clearFormValue(programContainer: ProgramContainer) {
    for (let section of programContainer.ListOfFormSections) {
      section.Visible = true;

      if (programContainer.Profile) {
        programContainer.Profile.address = {};
      }
      section.ListOfFormSubSections.forEach(subSection => {
        subSection.ListOfFormSectionElements.forEach(ele => {
          if (ele.Datatype != 'Label' && ele.Datatype != "HTML" && ele.Datatype != "TechError") {
            ele.Value = null;
            ele.day = null;
            ele.month = null;
            ele.year = null;
            ele.Visible = true;
            ele.Touched = false;
          }

          if (ele.Datatype == "SelectWithRichText") {
            ele.SelectionCode = "";
          }
          if (ele.Datatype == "CheckboxWithTextbox") {
            ele.Checked = false;
          }
          if (ele.Datatype == "Address") {
            ele.Address = null;
          }
          if (ele.Datatype === 'File') {
            ele.Value = null;
          }
        })
      })
    }
  }

  static maskString = (
    inputString: string,
    startIndex: number,
    endIndex?: number,
    maskCharacter = '*'
  ) => {
    if (!endIndex) {
      endIndex = inputString?.length;
    }
    return inputString ? inputString.replace(
      new RegExp(`^(.{${startIndex}}).{${endIndex - startIndex}}`),
      (_, prefix) => prefix + maskCharacter.repeat(endIndex || 0 - startIndex)
    ) : null;
  };




// static updateEntity = (programContainer: ProgramContainer) => {
//   let entity: FormEntity = new FormEntity();
//   entity.formId = programContainer.id;
//   const formValue = DataUtils.collectFormValue(programContainer);
//   console.log(formValue);
//   entity.formValue = formValue;
//   entity.id = formValue.id;
//   entity.createdById=formValue.createdById;
//   entity.createdDate=formValue.createdDate;
//   entity.template=formValue.template;
//   entity.status=formValue.status;
//   programContainer.Entity=entity;
// }

  static makeCompoenentReadonly = (programContainer) => {
    programContainer.ListOfFormSections.forEach(section => {
      section.ListOfFormSubSections.forEach(sub => {
        sub.ListOfFormSectionElements.forEach(ele => {
          console.log(ele);
          ele.Editable = "N";
        })
      })
    })
  }

  static saveToServer = async (isSubmit: boolean, programContainer: ProgramContainer,growl) => {
    if (programContainer.UpdateAPI) {
        let payload = DataUtils.collectFormValue(programContainer);
        payload.IsComplete = isSubmit;

        payload["UserId"] = programContainer["UserId"];

        if (!payload["FormId"])
            payload["FormId"] = programContainer["FormId"]

        if (!payload["UserId"])
            payload["UserId"] = programContainer.Profile?.UserId;

        let response = null;
        const fullUrl = programContainer.APIBasePath + "/" + programContainer.UpdateAPI;
        // this.setState({ isBusy: true });
        try {
            if (programContainer.UseProxy == "Y") {
                let postObject = {
                    url: fullUrl,
                    httpMethod: "POST",
                    payload: JSON.stringify(payload)
                };
                response = await axios.post(process.env.LAYOUT_API_URL + "/transfer", postObject,
                    {
                        headers: {
                            'ApplicationId': programContainer.CategoryId,
                            'Content-Type': 'application/json',
                        }
                    });
                // this.setState({ isBusy: false });
                growl.show({ severity: 'success', summary: 'Success Message', detail: 'Data saved' });
            } else {
                if (programContainer.AuthRequired === "ad") {
                    // const msalInstance = this.context["instance"];
                    // const msalAccounts = this.context["accounts"];
                    // const responseToken = await msalInstance.acquireTokenSilent({
                    //     scopes: [`api://${process.env.clientId}/Files.Read`],
                    //     account: msalAccounts[0],
                    // });

                    // payload.userId = responseToken.account.username;
                    payload.userId = SessionStorageService.getUserId();
                }


                response = await axios.post(fullUrl, payload, { withCredentials: true });
                let data = response.data;
                console.log(response);
           //     this.props.callbackOriginalData(data);


                if (isSubmit == true && "Y" == programContainer.HasSaveDraftButton) {
                    DataUtils.makeCompoenentReadonly(programContainer);
                    // this.setState({ isComplete: true });
                }
                programContainer.Entity=data;
                DataUtils.assignFormValue(programContainer);
                // this.setState({ isBusy: false });
                growl.show({ severity: 'success', summary: 'Success Message', detail: 'Data saved' });
            }
        } catch (ex) {
            console.log(ex);
            // this.setState({ isBusy: false });
            growl.show({ severity: 'error', summary: 'Error Message', detail: 'Saving data failed' });
        }
    }

}
}


interface FlattenedObject {
  [key: string]: any;
}

